import { Stack } from "@volca/ui/components/ui/stack";
import {
  TableCell,
  TableFooter,
  TableRow,
} from "@volca/ui/components/ui/table";
import { cn } from "@volca/ui/lib/utils";
import { cellClasses, ROW_CLASSES } from "./styles";

interface SimpleTableFooterProps {
  colSpan: number;
  children: React.ReactNode;
}

export const SimpleTableFooter = ({
  colSpan,
  children,
}: SimpleTableFooterProps) => (
  <TableFooter className="bg-transparent font-normal">
    <TableRow
      className={cn(
        ROW_CLASSES,
        "hover:bg-transparent data-[state=selected]:bg-transparent",
      )}
    >
      <TableCell
        colSpan={colSpan}
        className={cn(cellClasses(true), "px-4 py-6")}
      >
        <Stack
          direction="row"
          align="center"
          justify="center"
          gap={4}
          className="flex-wrap"
        >
          {children}
        </Stack>
      </TableCell>
    </TableRow>
  </TableFooter>
);
